import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const forWhomContent = {
  title: 'Este MegaPack es para vos si...',
  forYou: ['Sos profesional de la estimulación temprana, atención temprana o psicopedagogía infantil', 'Trabajás como terapista ocupacional, fonoaudiólogo/a o psicólogo/a infantil', 'Querés profesionalizar tus sesiones con material clínico ordenado', 'Buscás dejar de improvisar y trabajar con un sistema reproducible', 'Te interesa elevar el valor percibido de tu servicio profesional', 'Querés acompañar mejor a las familias con recursos visuales claros'],
  notForYou: ['Buscás un curso de formación teórica (este es un pack de material práctico)', 'No tenés formación previa en estimulación temprana o áreas afines', 'Esperás contenido en formato video o clases en vivo', 'No estás dispuesto/a a aplicar e imprimir el material en tu consulta']
};
export function ForWhom() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif text-center mb-16 text-brand-light" data-id="element-110">
          {forWhomContent.title}
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-emerald-900/30 rounded-2xl p-8" data-id="element-112">
            <h3 className="text-xl font-serif text-emerald-200 mb-6 flex items-center gap-2" data-id="element-113">
              <Check className="w-5 h-5" data-id="element-114" /> Es para vos
            </h3>
            <ul className="space-y-4" data-id="element-115">
              {forWhomContent.forYou.map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-light/90 font-sans" data-id="element-116">
                  <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-117" />
                  <span data-id="element-118">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-red-900/30 rounded-2xl p-8" data-id="element-119">
            <h3 className="text-xl font-serif text-red-200 mb-6 flex items-center gap-2" data-id="element-120">
              <X className="w-5 h-5" data-id="element-121" /> No es para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-122">
              {forWhomContent.notForYou.map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-light/70 font-sans" data-id="element-123">
                  <X className="w-5 h-5 text-red-400/70 shrink-0 mt-0.5" data-id="element-124" />
                  <span data-id="element-125">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}